import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import RelateFieldDetail from "./detail";
import RelateFieldEdit from "./edit";
import RelateFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type relate en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Relate() {
    return _jsx(_Fragment, { children: "Relate" });
}
var field = fieldsType.relate;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, RelateFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, RelateFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, RelateFieldList);
